import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import NavDropdown from '../NavDropdown';
import menuItems from './data.json';
import styles from './DestinationNavigation.module.scss';
import NestedMenu from '../NestedMenu';

const DestinationNavigation: FC = () => {
  const { t } = useTranslation('destination-navigation');

  return (
    <li className={styles.root}>
      <NavDropdown
        data-test="destination-nav"
        aria-label={t('heading')}
        heading={(
          <span className={styles.heading}>
            {t('explore')}
          </span>
        )}
        className={styles.dropdown}
        classNameModifier="nestedMenu"
        shouldDropdownPersist
      >
        {() => (
          <NestedMenu
            items={menuItems}
            translationNamespace="destination-navigation"
            variant="dropdown"
          />
        )}
      </NavDropdown>
    </li>
  );
};

export default DestinationNavigation;
